<template>
	<div class="ol-sm-12 col-lg-2" :class="{'close-filter': openFilters !== 'sort'}">
		<div v-if="name === 'stars'" class="filter__wrapper" :class="{open: 'open' === showList, close: 'open' !== showList}">
			<button class="filter"
					:class="{open: 'open' === showList, close: 'open' !== showList}"
					@click="updateShowList('open')"
			>
				{{showOrderingName(stars.name)}}
			</button>
			<ul v-show="'open' === showList"
				class="filter__list"
			>
				<li class="filter__list-item" @click="removeFilter">{{$t('filters.remove')}}</li>
				<li v-for="item in stars.items"
					class="filter__list-item"
					:class="{'filter__list-item--active': $store.getters.isOrderingActive(item.value)}"
					@click="selectFilter(item)"
				>
					{{item.name}}
				</li>
			</ul>
		</div>
		<div v-if="name === 'reviews'">
			<button class="filter"
					:class="{open: 'open' === showList, close: 'open' !== showList}"
					@click="updateShowList('open')"
			>
				{{showOrderingName(reviews.name)}}
			</button>
			<ul v-show="'open' === showList"
				class="filter__list"
			>
				<li class="filter__list-item" @click="removeFilter">{{$t('filters.remove')}}</li>
				<li v-for="item in reviews.items"
					class="filter__list-item"
					:class="{'filter__list-item--active': $store.getters.isOrderingActive(item.value)}"
					@click="selectFilter(item)"
				>
					{{item.name}}
				</li>
			</ul>
		</div>
	</div>
</template>

<script>
	import { mapActions, mapMutations } from 'vuex'

	export default {
		props: [
			'name',
			'openFilters'
		],
		data () {
			return {
				showList: '',
				stars: {
					name: this.$t('filters.stars.name'),
					value: 'stars',
					items: [
						{
							name: this.$t('filters.stars.most'),
							value: '-average_score'
						},
						{
							name: this.$t('filters.stars.least'),
							value: 'average_score'
						}
					]
				},
				reviews: {
					name: this.$t('filters.reviews.name'),
					value: 'reviews',
					items: [
						{
							name: this.$t('filters.reviews.most'),
							value: '-comments_count'
						},
						{
							name: this.$t('filters.reviews.least'),
							value: 'comments_count'
						}
					]
				}
			}
		},
		methods: {
			...mapActions(['fetchJudges']),
			...mapMutations(['addOrdering']),
			...mapMutations(['removeOrdering']),
			updateShowList (list) {
				if (this.showList === list) {
					this.showList = ''
				} else {
					setTimeout(() => {
						this.showList = list
					}, 0)
				}
			},
			closeFlitersLists (e) {
				const open = document.querySelector('.open')
				if (open && !e.target.matches('.filter__list, .filter__list *')) {
					this.showList = ''
				}
			},
			selectFilter (order) {
				this.addOrdering(order.value)
				this.fetchJudges()
				this.showList = ''
			},
			removeFilter () {
				this.removeOrdering()
				this.fetchJudges()
				this.showList = ''
			}
		},
		computed: {
			showOrderingName () {
				return name => {
					const ordering = this.$store.state.judges.activeOrdering
					return name === ordering ? ordering : name
				}
			}
		},
		created () {
			window.addEventListener('click', this.closeFlitersLists)
		},
		beforeDestroy () {
			window.removeEventListener('click', this.closeFlitersLists)
		}
	}
</script>

<style lang="scss" scoped>
	@import "../../../styles/variables.scss";
	@import "../../../styles/filters.scss";
</style>



// WEBPACK FOOTER //
// src/components/JudgesList/Filters/SortFilterComponent.vue